import { createAlignPlugin } from '@udecode/plate-alignment'
import { createBasicElementsPlugin } from '@udecode/plate-basic-elements'
import {
  createBoldPlugin,
  createItalicPlugin,
  createUnderlinePlugin,
} from '@udecode/plate-basic-marks'
import { plateUI } from './plateUI'
import { createMyPlugins } from './types'

export const formattingPlugins = createMyPlugins(
  [
    createBasicElementsPlugin(),
    createBoldPlugin(),
    createItalicPlugin(),
    createUnderlinePlugin(),
    createAlignPlugin(),
  ],
  {
    components: plateUI,
  },
)
